import { render, staticRenderFns } from "./ordingCard.vue?vue&type=template&id=08bf5082&scoped=true"
import script from "./ordingCard.vue?vue&type=script&lang=js"
export * from "./ordingCard.vue?vue&type=script&lang=js"
import style0 from "./ordingCard.vue?vue&type=style&index=0&id=08bf5082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bf5082",
  null
  
)

export default component.exports